"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validBuild = exports.parseBuild = void 0;
function parseBuild(buildstr) {
    var _a, _b;
    const parts = buildstr.split(':');
    let buildVersion = parts[0];
    let buildType = (_a = parts[1]) !== null && _a !== void 0 ? _a : '';
    let buildNumber = parts[2] ? parseInt(parts[2]) : 0;
    let secondaryBuildNumber = parts[3] ? parseInt(parts[3]) : 0;
    let startIndex = buildNumber;
    let endIndex = secondaryBuildNumber;
    if (parts.length > 1) {
        // assume in the format <version>:<type>:<num_1>:<num_2>
        buildVersion = parts[0];
        buildType = (_b = parts[1]) !== null && _b !== void 0 ? _b : '';
        buildNumber = parts[2] ? parseInt(parts[2]) : 0;
        secondaryBuildNumber = parts[3] ? parseInt(parts[3]) : 0;
        startIndex = buildNumber;
        endIndex = secondaryBuildNumber;
    }
    else {
        // assume it's just the build CL
        buildNumber = parseInt(buildstr);
    }
    return {
        buildVersion,
        buildType,
        buildNumber,
        secondaryBuildNumber,
        startIndex,
        endIndex,
    };
}
exports.parseBuild = parseBuild;
function validBuild(newBuildName, builds) {
    let conflictingBuildFound = false;
    let failReason = '';
    const newBuildData = parseBuild(newBuildName);
    const buildKeys = Object.keys(builds);
    for (let i = 0; i < buildKeys.length && !conflictingBuildFound; i++) {
        const previousBuildData = parseBuild(buildKeys[i]);
        if (newBuildData.buildVersion === previousBuildData.buildVersion) {
            if (newBuildData.buildType === 'R') {
                // conflict with
                // - any single values that lie in the range
                // - ranges with a starting or ending index that lies inside the previous range
                // - less than sets that begin in the range of begin later than the end index
                // - greater than sets that begin in the range or begin earlier than the starting index
                // specific builds
                if (previousBuildData.buildType === 'S' || previousBuildData.buildType === undefined) {
                    if (previousBuildData.buildNumber >= newBuildData.startIndex && previousBuildData.buildNumber <= newBuildData.endIndex) {
                        conflictingBuildFound = true;
                        failReason = 'the single build was found inside the existing range';
                    }
                }
                // ranges
                else if (previousBuildData.buildType === 'R') {
                    if (previousBuildData.startIndex >= newBuildData.startIndex && previousBuildData.startIndex <= newBuildData.endIndex) {
                        conflictingBuildFound = true;
                        failReason = 'the starting index was inside the existing range';
                    }
                    else if (previousBuildData.endIndex >= newBuildData.startIndex && previousBuildData.endIndex <= newBuildData.endIndex) {
                        conflictingBuildFound = true;
                        failReason = 'the end index was inside the existing range';
                    }
                    else if (previousBuildData.startIndex <= newBuildData.startIndex && previousBuildData.endIndex >= newBuildData.endIndex) {
                        conflictingBuildFound = true;
                        failReason = 'the range was equal to or contained the existing range';
                    }
                }
                // less than sets
                else if (previousBuildData.buildType === 'L') {
                    if (newBuildData.startIndex <= previousBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the starting index of the new range is less than the origin of an existing less than set';
                    }
                }
                // greater than set
                else if (previousBuildData.buildType === 'G') {
                    if (newBuildData.startIndex >= previousBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the starting index of the new range is greater than the origin of an existing greater than set';
                    }
                }
            }
            if (newBuildData.buildType === 'L') {
                // single values <= start
                // ranges with starting index <= start
                // greater than sets start <= start
                // specific builds
                if (previousBuildData.buildType === 'S' || previousBuildData.buildType === undefined) {
                    if (previousBuildData.buildNumber <= newBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the single build was less than or equal to the origin of the new set';
                    }
                }
                // ranges
                else if (previousBuildData.buildType === 'R') {
                    if (previousBuildData.startIndex <= newBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the origin is greater than the starting index of the existing range';
                    }
                }
                // less than sets
                else if (previousBuildData.buildType === 'L') {
                    if (newBuildData.buildNumber <= previousBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the origin of the new set is less than or equal to the origin of an existing less than set';
                    }
                }
                // greater than set
                else if (previousBuildData.buildType === 'G') {
                    if (newBuildData.buildNumber >= previousBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the origin of the new set is greater than or equal to the origin of an existing greater than set';
                    }
                }
            }
            if (newBuildData.buildType === 'G') {
                // single values >= start
                // ranges with ending index >= start
                // greater than sets start >= start
                if (previousBuildData.buildType === 'S' || previousBuildData.buildType === undefined) {
                    if (previousBuildData.buildNumber >= newBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the single build was greater than or equal to the origin of the new set';
                    }
                }
                // ranges
                else if (previousBuildData.buildType === 'R') {
                    if (previousBuildData.endIndex >= newBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the origin is greater than the ending index of the existing range';
                    }
                }
                // less than sets
                else if (previousBuildData.buildType === 'L') {
                    if (newBuildData.buildNumber <= previousBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the origin of the new set is less than or equal to the origin of an existing less than set';
                    }
                }
                // greater than set
                else if (previousBuildData.buildType === 'G') {
                    if (newBuildData.buildNumber >= previousBuildData.buildNumber) {
                        conflictingBuildFound = true;
                        failReason = 'the origin of the new set is greater than or equal to the origin of an existing greater than set';
                    }
                }
            }
        }
    }
    return {
        conflictingBuildFound,
        failReason,
    };
}
exports.validBuild = validBuild;
